export default __webpack_public_path__ + "static/ACaslonPro-Regular-13dfab1a9fb20448fd85dcb6f99e91b5.eot";